import { createModel, createSaga, createReducer } from '@/store/tools';
import { put, takeEvery } from 'redux-saga/effects';
import http from '@/assets/api/http';

/**
 * 当saga写法需要自定义实现时，请使用依赖注入，把第二个参数变成具体的saga创建实现函数
 */
const getContrListEnum = (T) => createSaga(T('getContrListEnum'), (type) => {
    return function* () {
        yield takeEvery(type, function* requestData(action) {
            try {
                let result = yield http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', { enumName: action.payload.enumName }, 'POST');
                switch (action.payload.type) {
                    case 'status'://状态
                        yield put({ type: T('status'), payload: result });
                        break;
                    case 'time'://日期
                        yield put({ type: T('time'), payload: result });
                        break;
                }
            } catch (e) {
                yield put({ type: 'SAGA_ERROR', payload: { error: e } });
            }
        });
    };
});

/**
 * 当reducer写法需要自定义实现时，请使用依赖注入，把第一个参数变成具体的reducer创建实现函数
 */
const contrListEnum = (T) => createReducer((autostate) => {
    return (state = autostate, action) => {
        switch (action.type) {
            case T('status'):
                return { ...state, statusList: action.payload.result };
            case T('time'):
                return { ...state, timeList: action.payload.result };
            default:
                return state;
        }
    };
}, { statusList: [], timeList: [], });
const dataList = { dataList: [], pageNum: 1, pageSize: 20, resultTotal: 0 };
const model = {
    namespace: 'contractlist',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getContractList': T('getContractList'),
            'getContractListment': T('getContractListment'),
            'getContrListEnum': T('getContrListEnum'),
            'getContractListDetail': T('getContractListDetail'),
            'getCreateDetail': T('getCreateDetail'),
        },
        actions: {
            'getContractList': A('getContractList'), // 客户端、骑士端列表数据
            'getContractListment': A('getContractListment'), // 合同列表-管理列表数据
            'getContrListEnum': A('getContrListEnum'), // 枚举
            'getContractListDetail': A('getContractListDetail'), // 合同列表-管理详情数据
            'getCleanDetail': C('getContractListDetail'), // 合同列表-管理清除详情数据
            'getCreateDetail': A('getCreateDetail'), // 合同列表-管理新建协议获取版本号
            'getCleanCreateDetail': C('getCreateDetail'), // 合同列表-管理-清除管理新建协议获取版本号
        },
        sagas: {
            'getContractList': S('getContractList', '/?cmd=com.xqxc.api.pig.mis.biz.account.ContractService.findContract', 'POST'),
            'getContractListment': S('getContractListment', '/?cmd=com.xqxc.api.pig.mis.biz.account.ContractService.findContractVersions'),
            'getContrListEnum': getContrListEnum(T),
            'getContractListDetail': S('getContractListDetail', '/?cmd=com.xqxc.api.pig.mis.biz.account.ContractService.detail', 'POST'),
            'getCreateDetail': S('getCreateDetail', '/?cmd=com.xqxc.api.pig.mis.biz.account.ContractService.newContractVersionNo', 'POST'),
        },
        reducers: {
            'contrList': R('getContractList', dataList),
            'contractListment': R('getContractListment', dataList),
            'contrListEnum': contrListEnum(T),
            'details': R('getContractListDetail', {}),
            'createDetail': R('getCreateDetail', {}),
        }
    })
};
export default createModel(model);